import { PurchaseReturnStatusEnum } from "./return-status-enum";

export const purchaseReturnStatusColors = {
  [PurchaseReturnStatusEnum.NONE]: "default",
  [PurchaseReturnStatusEnum.PARTIALLY_RETURNED]: "warning",
  [PurchaseReturnStatusEnum.FULLY_RETURNED]: "success",
};
